import Config from '../config/config';

function initDebug() {
  if (!window.Ra) {
    window.Ra = {
      debug: {
        history: [],
        store: {},
        log: [],
      },
    };
  }
}

const debugEnabled = typeof Config.debug !== 'undefined' && Config.debug;

export function trackAction(action) {
  if (debugEnabled) {
    initDebug();
    window.Ra.debug.history.push(action);
  }
}

export function trackStore(store) {
  if (debugEnabled) {
    initDebug();
    window.Ra.debug.store = store;
  }
}

export function log(message) {
  if (debugEnabled) {
    initDebug();
    window.Ra.debug.log.push(message);
  }
}

export function isDebugEnabled() {
  return debugEnabled;
}
